import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import * as Sentry from "@sentry/react"; // Sentry 임포트

// Sentry 초기화 추가
Sentry.init({
  dsn: "https://2e9bf96ef9590f796c24d4594cc2304a@o4511817354248192.ingest.us.sentry.io/4511817489317888",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
